import { QueryHookOptions } from '@apollo/client';
import { useCustomQuery } from '../../../../logic/api/graphQL/useCustomQuery';
import gql from 'graphql-tag';

export function useGetTagGroupsAndTagsGq(
  command: CommandGq,
  options: QueryHookOptions<DataGq, Variables> = {}
) {
  const query = useCustomQuery<DataGq, Variables>(gqTag, {
    ...options,
    variables: { command },
  });

  return {
    query,
    result: (query?.data ?? query?.previousData)?.projects?.getTagGroupsAndTags,
  };
}

const gqTag = gql`
  query GetTagGroupsAndTags($command: GetTagGroupsAndTagsCommand!) {
    projects {
      getTagGroupsAndTags(command: $command) {
        projectSearchVolume
        projectKeywordCount
        tagGroupAnalyses {
          tagGroupId
          tagGroupName
          searchVolume
          moreItemsCount
          tagAnalyses {
            tagId
            tagName
            searchVolume
          }
        }
      }
    }
  }
`;

interface DataGq {
  readonly projects: {
    readonly getTagGroupsAndTags: ResponseGq;
  };
}

export interface ResponseGq {
  readonly projectSearchVolume: number;
  readonly projectKeywordCount: number;
  readonly tagGroupAnalyses: TagGroupAnalysisGq[];
}

export interface TagGroupAnalysisGq {
  readonly tagGroupId: number;
  readonly tagGroupName: string;
  readonly searchVolume: number;
  readonly moreItemsCount: number;
  readonly tagAnalyses: TagAnalysisGq[];
}

export interface TagAnalysisGq {
  readonly tagId: number;
  readonly tagName: string;
  readonly searchVolume: number;
}

export interface Variables {
  readonly command: CommandGq;
}

export interface CommandGq {
  readonly projectId: number;
  readonly tagGroupIds: number[];
  readonly serpOnly: boolean;
  readonly limitItems: number;
}
